'use client';

import { useLayoutEffect } from 'react';

import { UserReferrer } from 'models';
import { UserHelpers } from 'helpers/UserHelpers';

import { LocalStorageService } from 'services/LocalStorageService';

export const ResourceProAttribution = () => {
    // A layout effect runs before the page.view effect, so the landing view is already attributed to RE+.
    useLayoutEffect(() => {
        const linkReferrer = new URLSearchParams(window.location.search).get('referrer');

        // Anyone who reaches an RE+Source PRO page signs up as an RE+ user, unless a link names another referrer.
        if (!linkReferrer || linkReferrer === UserReferrer.REPLUS) {
            LocalStorageService.store(UserHelpers.localStorageKey.referrer, UserReferrer.REPLUS);
        }
    }, []);

    return null;
};
